import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import D3Circle from '../../D3Components/D3Circle';
import RootStore from '../../../storage/RootStore';
import { constants } from '../../../Constants';
import { IOrgStageCoordsGetterOutput } from '../functions/getOrgStages-1';

import { getIDs } from '../functions/getID';
import { SelectionStore } from '../../../storage/Selection';

interface Props extends IOrgStageCoordsGetterOutput { }

const { CIRCLE } = constants;


export const NodeCircles: React.FC<Props> = observer(({
    arrayOrgNodes, arrayStages, connectionDotsCoords, orgStagesCoords
}) => {

    const { selection } = useContext(RootStore);

    return (<>
        <g id='connection-circles'>
            {/* Перехідні точки між етапами  */}
            {connectionDotsCoords && Object.keys(connectionDotsCoords).map(item => {
                let { x, y } = connectionDotsCoords[item]
                return <D3Circle key={`${item}-connecting-dot`} x={x} y={y} r={CIRCLE.RADIUS} fill='transparent' />
            })}
        </g>

        <g id="node-circles-new">

            {orgStagesCoords && Object.keys(orgStagesCoords)
                .filter(orgStageID => orgStagesCoords[orgStageID].node)
                .map((orgStageID, i) => {

                    let { x, y } = orgStagesCoords[orgStageID]

                    const { orgID, stageID } = getIDs(orgStageID)

                    const { r, fill, stroke, strokeWidth } = getNodeStyles({ selection, orgStageID })

                    const circleProps = { x, y, r, fill, stroke, strokeWidth }

                    return (<g>
                        <D3Circle key={`${orgStageID}-node`}
                            {...circleProps}
                            dataOrg={orgID}
                            cursor={'pointer'}
                            dataStage={stageID}
                            dataID={orgStageID}
                            onClick={() => {
                                selection.setOrgStage(orgStageID)
                            }}
                        />

                        {/* <D3Circle key={orgStageID+'_node-2'}
                            x={circleProps.x}
                            y={circleProps.y}
                            fill={'white'}
                            r={10}
                        /> */}
                    </g>)
                })}
        </g>
    </>)
})


const getNodeStyles = (opts: { selection: SelectionStore, orgStageID: string }): { r: number, fill: string, stroke: string, strokeWidth: number } => {

    const { selection, orgStageID } = opts
    const { orgID, stageID } = getIDs(orgStageID)

    let fill = CIRCLE.COLOR;  //// Color
    let r = CIRCLE.RADIUS  /// Radius
    let stroke = 'transparent'
    let strokeWidth = 0;


    if (
        (selection.orgStage === orgStageID)
        ||
        (selection.stage === stageID && !selection.org)
        ||
        (selection.org === orgID && !selection.stage)
    ) {
        fill = 'white';
        strokeWidth = 4
        stroke = CIRCLE.COLOR_SELECTED
        r = CIRCLE.RADIUS_SELECTED
    }


    return { r, fill, stroke, strokeWidth }
}